import { Stack } from '@mui/material';
import { Pagination as MuiPagination, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { IPaginationProps } from './types';
import { useTranslation } from 'react-i18next';

const Pagination = ({
  itemsPerPage,
  currentPage,
  onPageChange,
  totalItems,
}: IPaginationProps) => {
  const [page, setPage] = useState(0);

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    setPage(currentPage);
  }, [currentPage]);

  const handleOnPageChange = (page: number) => {
    setPage(page);
    onPageChange(page);
  };

  const { t } = useTranslation();
  const start = (currentPage - 1) * itemsPerPage + 1;
  const end = Math.min(start + itemsPerPage - 1, totalItems);

  return (
    <>
      <Stack direction='row' sx={{justifyContent: 'space-between'}}>
        <Typography>
          {/* {`Εμφάνιση ${start} εώς ${end} από ${totalItems} εγγραφές`} */}
          {`${t('Εμφάνιση')} ${start} ${t('εώς')} ${end} ${t('από')} ${totalItems} ${t('εγγραφές')}`}
        </Typography>
        <MuiPagination sx={{mb: 1}}
          count={totalPages}
          page={page}
          onChange={(event, page) => handleOnPageChange(page)}
        />
      </Stack>
    </>
  );
};

export default Pagination;
